import { render } from "./QuizFeature.vue?vue&type=template&id=33365ac9&scoped=true"
import script from "./QuizFeature.vue?vue&type=script&lang=js"
export * from "./QuizFeature.vue?vue&type=script&lang=js"

import "@/assets/css/quiz.sass?vue&type=style&index=0&id=33365ac9&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33365ac9"]])

export default __exports__